import { render, staticRenderFns } from "./ChampionshipFutureSiteCard.vue?vue&type=template&id=284a7e4d&scoped=true&"
import script from "./ChampionshipFutureSiteCard.vue?vue&type=script&lang=js&"
export * from "./ChampionshipFutureSiteCard.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipFutureSiteCard.vue?vue&type=style&index=0&id=284a7e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a7e4d",
  null
  
)

export default component.exports